import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { Transporter } from '../../models/transporter';

@Injectable({
  providedIn: 'root',
})
export class TransporterService {
  currentDomain = environment.currentApiHostname
  apiUrl = `https://${this.currentDomain}/api/general`;


  constructor(private http: HttpClient) {}

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
        `/transporters?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }



  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<Transporter>>(
      this.apiUrl +  `/transporters/index/all`,
      options
    );
  }

  /** Overall fleet/transporter summary numbers for the list cards (across ALL transporters). */
  stats() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };
    return this.http.get<{
      total_transporters: number; active_transporters: number;
      total_trucks: number; trucks_in_yard: number; active_assignments: number;
    }>(this.apiUrl + `/transporters/stats/overview`, options);
  }

  /** The transporter's fleet, derived from its check-ins (distinct horse registrations + status). */
  fleet(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };
    return this.http.get<{
      trucks: Array<{ horse_registration: string; status: string; in_yard: boolean; last_seen: number; last_purpose?: string; visits: number; make?: string; model?: string; truck_type?: string; colour?: string }>;
      summary: { total_trucks: number; trucks_in_yard: number; checked_out: number };
      recent_activity: Array<{ reference: string; horse_registration: string; purpose?: string; status: string; date: number }>;
    }>(this.apiUrl + `/transporters/fleet/${uuid}`, options);
  }

  /** One truck's full check-in / clear / checkout history (Truck detail page). */
  truckActivity(transporterUuid: string, reg: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };
    return this.http.get<{
      summary: { horse_registration: string; make?: string; model?: string; truck_type?: string; colour?: string; status?: string; in_yard: boolean; visits: number; last_seen?: number; transporter_uuid: string };
      timeline: Array<{ uuid: string; reference: string; status: string; purpose?: string; parking_bay?: string; driver?: string; containers: string[]; check_in_date?: number; date_created: number; time_cleared?: number; time_checked_out?: number; amount_paid?: any; released_on_account: boolean; remarks?: string }>;
    }>(this.apiUrl + `/transporters/${transporterUuid}/truck-activity?reg=${encodeURIComponent(reg)}`, options);
  }

  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };


    return this.http.get(
      this.apiUrl +
        `/exports/transporters/export/${type}?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }


  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Transporter>(
      this.apiUrl +  `/transporters/${uuid}`,
      options
    );
  }

  store(category: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<Transporter>(
      this.apiUrl +  `/transporters`,
      category,
      options
    );
  }

  update(category: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<Transporter>(
      this.apiUrl +  `/transporters/update/${uuid}`,
      category,
      options
    );
  }
}
